import { React, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import { useDisclosure } from '@mantine/hooks';
// import { Button, Burger} from '@mantine/core';
// import { IconBuildingEstate, IconBarrierBlock, IconBrandHipchat, IconUserPlus } from '@tabler/icons-react';
import LogoNavbar from '../../composents/Logo/NavbarLogo/Logo';
// import LogoBurgerMenu from '../../composents/Logo/BurgerMenuLogo/LogoBurgerMenu';

const Navbar = (props) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    // const [opened, { toggle }] = useDisclosure(false);
    // const label = opened ? 'Close navigation' : 'Open navigation';
    // const location = useLocation();

    // const isOnPrestaPage = location.pathname === "/p/login";

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>       
            <div className="navbar">
                   
                    
                {isMobile ? (
                    <>
                        <div className='horizontal iCenter jCenter spaceBtw'>
                            <div className='mrgL10'>
                                <Link to="/">
                                    <LogoNavbar />
                                </Link>
                            </div>
            
                            {/* <div className='horizontal iCenter mrgT10 mrgLauto'>
                                {(location.pathname === '/app/login' || location.pathname ==='/') && 
                                    <div>
                                        <Link to='/app/login'>
                                            <Button variant="default" color="rgba(26, 26, 26, 1)" size="xs" radius="xl">
                                                <p className='txt13 '>Connexion</p>
                                            </Button>
                                        </Link>
                                    </div>
                                }
                                <div className='mrgL10 mrgR20'>
                                    <Burger opened={opened} onClick={toggle} aria-label={label} />
                                </div>
                            </div> */}
                        </div>

                        {/* {opened &&  (                            
                            <ul className="menu__box">
                                <Link to="/">
                                    <LogoBurgerMenu />
                                </Link>
                                <li><Link to="/app/login" className="menu__item mrgT20">
                                    <div className="horizontal">
                                        <IconBuildingEstate width={18} className="mrgR10 logo_size"/>Propriétaires
                                    </div>
                                    </Link>
                                </li>
                                <li><Link to="/p/login" className="menu__item">
                                    <div className="horizontal">
                                        <IconBarrierBlock width={18} className="mrgR10 logo_size"/>Espace Prestataires
                                    </div>
                                    </Link>
                                </li>
                                <li><Link to="/contact" className="menu__item">
                                    <div className="horizontal">
                                        <IconBrandHipchat width={18} className="mrgR10 logo_size"/>Contact
                                    </div>
                                    </Link>

                                </li>
                                <li><Link to="/signup" className="menu__item">
                                    <div className="horizontal terracotaT">
                                        <IconUserPlus width={18} className="mrgR10 logo_size"/>S'inscrire
                                    </div>
                                    </Link>
                                </li>
                            </ul>
                        )} */}
                    </>
                ) : (
                    <>
                        <div className='horizontal iCenter w100 jCenter spaceBtw bWhite'>
                            <div className='mrgL10'>
                                <Link to="/">
                                    <LogoNavbar />
                                </Link>
                            </div>
                            {/* <div className='horizontal mrgT10 iCenter mrgLauto'>
                                {isOnPrestaPage
                                ? <></>
                                : <>
                                   <div className='mrgR20'>
                                    <Link to='/app/login'>
                                        <Button variant="transparent" color="gray" size="lg">
                                            <p className='txt18 '>Connexion</p>
                                        </Button>
                                    </Link>
                                    </div>
                                    </>
                                }
                                
                                
                                
                                
                            </div> */}
                        </div>
                       
                    </>
                )}
                   
            </div>       
        </>
      )}
      
  
  export default Navbar;